/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that they will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
let visualSuccessFunc = null;
let visualErrorFunc = null;
let srAlertFunc = null;
export function initialize(_ref) {
  let _ref$visualSuccessCal = _ref.visualSuccessCallback,
      visualSuccessCallback = _ref$visualSuccessCal === void 0 ? visualSuccessFunc : _ref$visualSuccessCal,
      _ref$visualErrorCallb = _ref.visualErrorCallback,
      visualErrorCallback = _ref$visualErrorCallb === void 0 ? visualErrorFunc : _ref$visualErrorCallb,
      _ref$srAlertCallback = _ref.srAlertCallback,
      srAlertCallback = _ref$srAlertCallback === void 0 ? srAlertFunc : _ref$srAlertCallback;
  visualSuccessFunc = visualSuccessCallback;
  visualErrorFunc = visualErrorCallback;
  srAlertFunc = srAlertCallback;
}
export function alert(message) {
  let isError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;

  if (isError) {
    visualErrorFunc(message);
  } else {
    visualSuccessFunc(message);
  }
}
export function srAlert(message) {
  srAlertFunc(message);
}